import { render, staticRenderFns } from "./DisciplinaryLines.vue?vue&type=template&id=112f7f7f"
import script from "./DisciplinaryLines.vue?vue&type=script&lang=js"
export * from "./DisciplinaryLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports